import api from "../../../../services/api";

import { EmailConfigToGet } from "../../models/interfaces";

const baseUrl = process.env.REACT_APP_PROVIDERDOCUMENT;

export const getEmailConfig = async () => {
  try {
    const {
      data: { data },
    } = await api.get(`${baseUrl}/emailConfig`);
    return data.emailConfig;
  } catch (err: any) {
    throw new Error(err);
  }
};

export const sendEmailConfig = async (params: EmailConfigToGet) => {
  try {
    await api.put(`${baseUrl}/emailConfig`, params);
    return true;
  } catch (err) {
    return false;
  }
};
